module.exports = __webpack_public_path__ + "img/icon_contact_02.e8125fcf.png";